import { TourBagDetail } from '@/api/models';
import { DeletedTourBag } from '@/api/models/DeletedTourBag';
import { isIOSWebView } from './isIOSWebView';

export const createDeletedTourBag = (bag: TourBagDetail) => {
  const deletedTourBag: DeletedTourBag = {
    tourBagDetailId: bag.tourBagDetailId,
    serialMstrId: bag.serialMstrId,
    appUserName: bag.appUserName,
    playerId: bag.playerId,
    playerName: bag.playerName,
    tourBagMstrId: bag.tourBagMstrId,
    tourId: bag.tourId,
    headTypeId: bag.headTypeId,
    itemNo: bag.itemNo,
    editSource: isIOSWebView ? 'iOS' : 'web',
    tourName: bag.tourName,
    headTypeDescription: bag.headTypeDescription,
    hand: bag.hand,
    headModelName: bag.headModelName,
    shaftName: bag.shaftName,
    shaftPinstamp: bag.shaftPinstamp,
    shaftCosmetic: bag.shaftCosmetic,
    shaftTippingDigit: bag.shaftTippingDigit,
    shaftTippingFraction: bag.shaftTippingFraction,
    isShaftLengthFinished: bag.isShaftLengthFinished,
    shaftLengthDigit: bag.shaftLengthDigit,
    shaftLengthDigitId: bag.shaftLengthDigitId,
    shaftLengthDigitId1: bag.shaftLengthDigitId1,
    shaftLengthFraction: bag.shaftLengthFraction,
    shaftLengthFractionId: bag.shaftLengthFractionId,
    shaftLengthFractionId1: bag.shaftLengthFractionId1,
    shaftFlexName: bag.shaftFlexName,
    metaName: bag.metalName,
    familyName: bag.familyName,
    familyNote: bag.familyNote,
    settingName: bag.settingName,
    cgFlatWeightName: bag.cgFlatWeightName,
    cgFlatWeightId: bag.cgFlatWeightId,
    loftName: bag.loftName,
    loftDigit: bag.loftDigit,
    lieFraction: bag.lieFraction,
    measuredLoft: bag.measuredLoft,
    laserNo: bag.laserNo,
    ct: bag.ct,
    ctLocation: bag.ctLocation,
    swingWtPrefixName: bag.swingWtPrefixName,
    swingWtPrefixId: bag.swingWtPrefixId,
    swingWtSuffixName: bag.swingWtSuffixName,
    swingWtSuffixId: bag.swingWtSuffixId,
    gripType: bag.gripType,
    gripTape: bag.gripTape,
    gripSize: bag.gripSize,
    tape: bag.tape,
    rndRib: bag.rndRib,
    logo: bag.logo,
    sleeve: bag.sleeve,
    sleeveName: bag.sleeveName,
    shaftBendName: bag.shaftBendName,
    shaftBendId: bag.shaftBendId,
    yearName: bag.yearName,
    lie: bag.lie,
    sightLine: bag.sightLine,
    neck: bag.neck,
    weights: bag.weights,
    headWeight: bag.headWeight,
    headWeightLocationLookupId: bag.headWeightLocationLookupId,
    headWeightLocationLookupName: bag.headWeightLocationLookupName,
    headWeightNumberLookupId: bag.headWeightNumberLookupId,
    headWeightNumberLookupName: bag.headWeightNumberLookupName,
    headWeightLocationAftLookupId: bag.headWeightLocationAftLookupId,
    headWeightLocationAftLookupName: bag.headWeightLocationAftLookupName,
    headWeightNumberAftLookupName: bag.headWeightNumberAftLookupName,
    headWeightNumberAftLookupId: bag.headWeightNumberAftLookupId,
    headFinishName: bag.headFinishName,
    headFinishNote: bag.headFinishNote,
    stamping: bag.stamping,
    grindDetails: bag.grindDetails,
    ratGlue1: bag.ratGlue1,
    ratGlue2: bag.ratGlue2,
    ratGlue3: bag.ratGlue3,
    ratGlue4: bag.ratGlue4,
    ratGlue5: bag.ratGlue5,
    ratGlue6: bag.ratGlue6,
    ratGlue7: bag.ratGlue7,
    gripSizeId: bag.gripSizeId,
    gripTypeId: bag.gripTypeId,
    yearId: bag.yearId,
    metalId: bag.metalId,
    headModelId: bag.headModelId,
    loftId: bag.loftId,
    loftDigitId: bag.loftDigitId,
    loftFraction: bag.loftFraction,
    loftFractionId: bag.loftFractionId,
    lieDigit: bag.lieDigit,
    lieDigitId: bag.lieDigitId,
    lieFractionId: bag.lieFractionId,
    shaftFlexId: bag.shaftFlexId,
    settingId: bag.settingId,
    sleeveId: bag.sleeveId,
    headFinishId: bag.headFinishId,
    familyId: bag.familyId,
    orderDetailId: bag.orderDetailId,
    isActive: false,
    deletedCreateDate: bag.createDate,
    deletedCreateUserGuid: bag.createUserGuid,
    deletedModifyDate: bag.modifyDate,
    deletedModifyUserGuid: bag.modifyUserGuid,
    modifyDate: bag.modifyDate,
    modifyUserGuid: bag.modifyUserGuid,
    createDate: bag.createDate,
    createUserGuid: bag.createUserGuid,
    tourBagMstrRowGuid: bag.tourBagMstrRowGuid,
    rowGuid: bag.rowGuid,
    notes: bag.notes,
  };

  return deletedTourBag;
};
